import { Action } from '../types/types';
import { SET_PPTX_DECK_ANIMATIONS_INFO } from '../actions/pptx-deck-animations';
import { PptxDeckSlideInfo } from '../../utils/pptx-deck-animations-reconcile';

export interface PptxDeckAnimationsInfo {
	slides: PptxDeckSlideInfo[];
}

export interface PptxDeckAnimationsState {
	// keyed by mediaId; string | number matches the repo's numeric-ID-map
	// precedent (masks.ts) since fkId/mediaId can arrive as a string.
	info: Record<string | number, PptxDeckAnimationsInfo>;
}

export const initialPptxDeckAnimationsState: PptxDeckAnimationsState = {
	info: {},
};

const actions: Map<any, Function> = new Map([
	[
		SET_PPTX_DECK_ANIMATIONS_INFO,
		(state: PptxDeckAnimationsState, action: Action) => ({
			...state,
			info: {
				...state.info,
				[action.payload.mediaId]: { slides: action.payload.slides },
			},
		}),
	],
]);

export const PptxDeckAnimationsReducer = (
	state: PptxDeckAnimationsState = initialPptxDeckAnimationsState,
	action: Action = { type: '', payload: {} },
) => actions.get(action.type)?.(state, action) ?? state;
